module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot1-8d963b53276dd0c1f1d0742e70c9e383.png";